import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // scroll to top on route change
    }, [pathname]);

    return null; // no UI
};

export default ScrollToTop;